/** @format */

/**
 * 平台mac地址不是真是mac地址，只作为唯一标识使用，以下正则与后台相同，不可修改！！！ shiguohao@xlink.cn
 * @param tip 提示语
 */
export const mac = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[-_0-9a-zA-Z]{2,100}$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验是否为整型
 * @param tip 提示语
 */
export const integer = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (rule.isStrict && !/^(0|-?[1-9][0-9]*)$/.test(value)) {
      callback(new Error(tip));
    } else if (!rule.isStrict && !/^[0-9]\d*$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验是否只输入字母，数字或下划线
 * @param tip 提示语
 */
export const word = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^\w+$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验是否包含空格
 * @param tip 提示语
 */
export const trim = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    let trimLength = 0;

    if (!String.prototype.trim) {
      trimLength = String(value).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '').length;
    } else {
      trimLength = String(value).trim().length;
    }

    if (rule.all) {
      // 字符串不能有空格
      if (!/^\S*$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
      return;
    }
    if (typeof value === 'string' && !(trimLength === value.length)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验SN格式
 * @param tip 提示语
 */
export const sn = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) return callback();
    if (!/^[0-9a-zA-Z][0-9a-zA-Z-]*$/i.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验邮箱格式
 * @param tip 提示语
 */
export const email = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    // if (!/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) { // 旧版验证规则
    /* eslint-disable no-useless-escape */
    // if (!/^[A-Za-z0-9]+([._\\-]*[A-Za-z0-9])*@([A-Za-z0-9]+[-A-Za-z0-9]*[A-Za-z0-9]+.){1,63}[A-Za-z0-9]+$/.test(value)) { // 后端验证规则
    if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value
      )
    ) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验邮箱格式
 * @param tip 提示语
 */
export const fixedEmail = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    // 某些邮箱要求纯数字，如123456@123.456的形式
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验手机号码是否合法
 * @param tip 提示语
 */
export const phoneReg = /^(1[0-9][0-9])\d{8}$/;
// /^1\d{10}$/
// /^(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[579])[0-9]{8}$/
export const phone = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (value && !phoneReg.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验手机号码是否合法，带区号
 * @param tip 提示语
 */
export const fixedPhone = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (value === '') {
      callback();
    } else {
      // if (/^((0\d{2,3}-\d{7,8})|((1[0-9][0-9])\d{8}))$/.test(value)) {
      if (/^(((1[0-9][0-9])\d{8}))$/.test(value)) {
        callback();
      } else {
        callback(new Error(tip));
      }
    }
  };
};

/**
 * 校验是否为数字
 * @param tip 提示语
 */
export const isNumber = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (value === '') {
      callback();
    } else {
      if (/^[0-9]*$/.test(value)) {
        callback();
      } else {
        callback(new Error(tip));
      }
    }
  };
};

/**
 * 校验URL
 * @param tip 提示语
 */
export const url = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^(http:\/\/|https:\/\/)(.{4,})$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验首字母大写的字符串
 * @param tip 提示语
 */
export const account = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[A-Z][a-z0-9_]*$/i.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验是否为大写字母
 * @param tip 提示语
 */
export const upper = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[A-Z]+$/i.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验密码是否为8-16位，并且包含大小写字母和数字
 * @param tip 提示语
 */
export const password = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^(?=.*[0-9].*)(?=.*[a-z].*)(?=.*[A-Z].*)[0-9A-Za-z]{8,16}$/.test(value)) {
      // 后台验证规则
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验密码是否为6-16位，并且至少一个字母和至少一个数字
 * @param tip 提示语
 */
export const passwordNext = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,16}$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 用户名必须为6-32位，并且只能输入数字、字母、下划线，且数字不能排在最前面
 * @param tip 提示语
 */
export const username = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[_a-zA-Z][_a-zA-Z0-9]{5,31}$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验数据端点名字
 * @param tip 提示语
 */
export const datapointName = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[a-zA-Z0-9_-]{1,32}$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 只能输入数字、字母、下划线、美元符号，而且数字不能排在最前面
 * @param tip 提示语
 */
export const variate = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[a-zA-Z_$]+[a-zA-Z0-9_$]{1,32}$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验authKey是否为长度32字节的十六进制
 * @param tip 提示语
 */
export const authkey = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[a-fA-F0-9]{32}$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 不能为连续空格
 * @param tip 提示语
 */
export const contiguousSpaces = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (/[\u0020\s]{2,}/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 小数点后位数必须为一到两位
 * @param tip 提示语
 */
export const tofixed2 = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^([1-9]\d*|0)(\.\d{1,2})?$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 校验身份证格式
 * @param tip 提示语
 */
export const idNumber = (tip: string, required?: boolean) => {
  return function(rule: any, value: any, callback: Function) {
    if (required === false && !value) {
      callback();
      return;
    }
    if (!/(^\d{15}$)|(^\d{17}([0-9]|[x,X])$)/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 普通证件号码，1-18位
 * @param tip 提示语
 */
export const normalIdNumber = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[A-Z0-9]{1,18}$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 不能选之前的时间
 * @param tip 提示语
 */
export const validDateFromToday = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (new Date(value).getTime() < new Date().getTime()) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 不能选之后的时间
 * @param tip 提示语
 */
export const validDateByToday = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (new Date(value).getTime() > new Date().getTime()) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 版本号检查
 * @param tip 提示语
 */
export const version = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^([0-9]|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])(\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])){2}$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 以英文/数字/中文开头，不要包含空格
 * @param tip 提示语
 */
export const chineseName = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[\u4e00-\u9fa5a-zA-Z\d_]\S*$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 只允许中英文和数字
 * @param tip 提示语
 */
export const chineseNameNext = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[\u4e00-\u9fa50-9a-zA-Z]*$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 只允许中英文
 * @param tip 提示语
 */
export const chineseNamePro = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^[\u4e00-\u9fa5a-zA-Z]*$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 不能重名
 * @param tip 提示语
 */
export const repeatName = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    let names = rule.data || [];
    let ignoreName = rule.ignore;

    if (names.indexOf(value) !== -1 && ignoreName !== value) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 不可填入错误格式数字，负数和非数字字符
 * @param tip 提示语
 */
export const isPositiveNum = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};

/**
 * 不允许中文
 * @param tip 提示语
 */
export const noChineseName = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (/[\u4e00-\u9fa5]/g.test(value)) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};
/**
 * 校验手机号码是否合法
 * @param tip 提示语
 */
export const mobile = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^(1[3-9][0-9])\d{8}$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
/**
 * 6-16位的数字、字母、或数字字母组合，区分大小写
 * @param tip 提示语
 */
export const accountValidation = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^[A-Za-z0-9]{6,16}$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
/**
 * 6-10位的数字、字母、或数字字母组合，区分大小写
 * @param tip 提示语
 */
export const pwdValidation = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^[A-Za-z0-9]{6,10}$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
/**
 * 正整数
 * @param tip 提示语
 */
export const positiveInteger = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
/**
 * 非负整数
 * @param tip 提示语
 */
export const nonnegativeInteger = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^[0-9]+?$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};

/**
 * 非负整数 且不为0
 * @param tip 提示语
 */
export const nonnegativeInteger0 = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^\+?[1-9]\d*$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
/**
 * 价格 两位小数
 * @param tip 提示语
 */
export const price = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*)|0)$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
/**
 * 价格 两位小数 大于0
 * @param tip 提示语
 */
export const postivePrice = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
/**
 * 7-20位的数字、字母、或数字字母组合，区分大小写
 * @param tip 提示语
 */
export const saleCodeValidation = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^[A-Za-z0-9]{7,20}$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};

export const chineseCharacter = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^[A-Za-z0-9\u4E00-\u9FA5]{1,20}$/.test(value)) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
/**
 * 校验邮箱格式 非必填
 * @param tip 提示语
 */
export const emailNot = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value
      )
    ) {
      callback(new Error(tip));
    } else {
      callback();
    }
  };
};
/**
 * 价格 两位小数 大于0
 * @param tip 提示语
 */
export const postiveZero = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (!/^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/.test(value) && value != 0) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
/**
 * 价格 不大于999
 * @param tip 提示语
 */
export const smallPrice = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (value > 999) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
